import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=8ac78f94&scoped=true"
import script from "./Template.vue?vue&type=script&lang=ts&setup=true"
export * from "./Template.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Template.vue?vue&type=style&index=0&id=8ac78f94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac78f94",
  null
  
)

export default component.exports